module.exports = __webpack_public_path__ + "img/84000.87e943c3.jpg";